import { render, staticRenderFns } from "./_pendingTicketAffiliate.vue?vue&type=template&id=3a5ff0da&lang=pug"
import script from "./_pendingTicketAffiliate.vue?vue&type=script&lang=js"
export * from "./_pendingTicketAffiliate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports